var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimulatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    fill: "none",
    viewBox: "0 0 6 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3 .559l-.522.906h1.044L3 .559zM3.18.105a.21.21 0 0 0-.363 0l-.824 1.43a.21.21 0 0 0 .182.314h1.648a.21.21 0 0 0 .181-.314L3.181.105zM5.441 3l-.906-.522v1.044L5.44 3zm.454.181a.21.21 0 0 0 0-.362l-1.43-.824a.21.21 0 0 0-.314.181v1.648a.21.21 0 0 0 .314.181l1.43-.824zM.559 3l.906.522V2.478L.559 3zm-.454-.182a.21.21 0 0 0 0 .363l1.43.824a.21.21 0 0 0 .314-.181V2.176a.21.21 0 0 0-.314-.182l-1.43.824zM3 5.441l.522-.906H2.478L3 5.44zm-.181.454c.08.14.282.14.362 0l.824-1.43a.21.21 0 0 0-.181-.314H2.176a.21.21 0 0 0-.181.314l.824 1.43z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulatorIcon);
export default __webpack_public_path__ + "static/media/simulator_icon.64285724806cd4864f39f3438339cde4.svg";
export { ForwardRef as ReactComponent };